import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircleIcon, ClockIcon, GiftIcon } from 'lucide-react';
const BenefitsSection: React.FC = () => {
  return <section className="w-full bg-background py-16" data-id="element-14">
      <div className="container mx-auto px-4 md:px-8 max-w-4xl" data-id="element-15">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center mb-12" data-id="element-16">
          <h2 className="text-3xl md:text-4xl font-serif font-bold text-secondary mb-2" data-id="element-17">
            <span className="text-primary" data-id="element-18">🔥</span> Lo que recibes al unirte
          </h2>
        </motion.div>
        <div className="bg-white p-8 rounded-2xl shadow-lg mb-12" data-id="element-19">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-8" data-id="element-20">
            <motion.div initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.4,
            delay: 0.1
          }} className="flex items-start gap-3" data-id="element-21">
              <CheckCircleIcon className="text-primary flex-shrink-0 mt-1" data-id="element-22" />
              <p data-id="element-23">Plan paso a paso de 21 días.</p>
            </motion.div>
            <motion.div initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.4,
            delay: 0.15
          }} className="flex items-start gap-3" data-id="element-24">
              <CheckCircleIcon className="text-primary flex-shrink-0 mt-1" data-id="element-25" />
              <p data-id="element-26">Menús semanales fáciles y ricos.</p>
            </motion.div>
            <motion.div initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.4,
            delay: 0.2
          }} className="flex items-start gap-3" data-id="element-27">
              <CheckCircleIcon className="text-primary flex-shrink-0 mt-1" data-id="element-28" />
              <p data-id="element-29">Listas de compra imprimibles.</p>
            </motion.div>
            <motion.div initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.4,
            delay: 0.25
          }} className="flex items-start gap-3" data-id="element-30">
              <CheckCircleIcon className="text-primary flex-shrink-0 mt-1" data-id="element-31" />
              <p data-id="element-32">Recetario básico sin azúcar añadido.</p>
            </motion.div>
            <motion.div initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.4,
            delay: 0.3
          }} className="flex items-start gap-3" data-id="element-33">
              <CheckCircleIcon className="text-primary flex-shrink-0 mt-1" data-id="element-34" />
              <p data-id="element-35">Snacks rápidos para urgencias de antojos.</p>
            </motion.div>
            <motion.div initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.4,
            delay: 0.35
          }} className="flex items-start gap-3" data-id="element-36">
              <CheckCircleIcon className="text-primary flex-shrink-0 mt-1" data-id="element-37" />
              <p data-id="element-38">Guía emocional anti-ansiedad.</p>
            </motion.div>
            <motion.div initial={{
            opacity: 0,
            y: 20
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.4,
            delay: 0.4
          }} className="flex items-start gap-3 md:col-span-2" data-id="element-39">
              <CheckCircleIcon className="text-primary flex-shrink-0 mt-1" data-id="element-40" />
              <p data-id="element-41">Alternativas dulces sin trampas.</p>
            </motion.div>
          </div>
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: 0.5
        }} className="flex items-center gap-3 justify-center bg-primary/10 p-4 rounded-lg" data-id="element-42">
            <ClockIcon className="text-primary" data-id="element-43" />
            <p className="font-medium" data-id="element-44">
              Tiempo de aplicación diario: máximo 10 minutos.
            </p>
          </motion.div>
        </div>
        <div className="bg-white p-8 rounded-2xl shadow-lg" data-id="element-45">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6
        }} className="flex items-center justify-center gap-3 mb-8" data-id="element-46">
            <GiftIcon className="text-primary" size={28} data-id="element-47" />
            <h3 className="text-2xl font-serif font-bold text-secondary" data-id="element-48">
              BONUS EXCLUSIVOS
            </h3>
          </motion.div>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8" data-id="element-49">
            <motion.div initial={{
            opacity: 0,
            scale: 0.95
          }} whileInView={{
            opacity: 1,
            scale: 1
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.5
          }} className="bg-secondary/5 p-6 rounded-xl" data-id="element-50">
              <div className="bg-primary text-white w-8 h-8 rounded-full flex items-center justify-center font-bold mb-4" data-id="element-51">
                1️⃣
              </div>
              <h4 className="text-xl font-medium text-secondary mb-2" data-id="element-52">
                Guía "Navidades Sin Azúcar"
              </h4>
              <p data-id="element-53">Para que no retrocedas aunque haya turrones y postres.</p>
            </motion.div>
            <motion.div initial={{
            opacity: 0,
            scale: 0.95
          }} whileInView={{
            opacity: 1,
            scale: 1
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.5,
            delay: 0.2
          }} className="bg-secondary/5 p-6 rounded-xl" data-id="element-54">
              <div className="bg-primary text-white w-8 h-8 rounded-full flex items-center justify-center font-bold mb-4" data-id="element-55">
                2️⃣
              </div>
              <h4 className="text-xl font-medium text-secondary mb-2" data-id="element-56">
                Guía Disruptores Endocrinos
              </h4>
              <p data-id="element-57">Cambios simples en tu día a día que ayudan a:</p>
              <div className="mt-2 space-y-1" data-id="element-58">
                <p data-id="element-59">
                  <span className="text-accent" data-id="element-60">✨</span> Desinflamar.
                </p>
                <p data-id="element-61">
                  <span className="text-accent" data-id="element-62">✨</span> Mejorar energía.
                </p>
                <p data-id="element-63">
                  <span className="text-accent" data-id="element-64">✨</span> Cuidar tus hormonas.
                </p>
              </div>
            </motion.div>
          </div>
        </div>
      </div>
    </section>;
};
export default BenefitsSection;